import {getCC, getLPM, getRPM} from '../formulas/calculate_CC_RPM_FLOW'
import valves from './build/valves';
import hoses from './hose/build';
import motorConfig from './motor/build';
import options from './build/options';
import orderMixin from "../../mixins/orderMixin";
import router from "../../router";
import lids from "@/store/modules/lids";
import cart from "@/store/modules/cart";
import axios from "axios";

const defaultState = {
    motor: null,
    pump: null,
    tank: null,
    circuit: 5,
    valveType: 2,
    electricalBox: null,
    wheels: false,
    cooler: false,
    loading: false,
    lid: null,
    tankerFloat: null,
    waterAbsorbentTankAeration: null,
    extraProductId: null,
    dynamo: null,
};

export default {
    namespaced: true,
    modules: {
        valves,
        options,
        hoses,
        motorConfig,
        lids,
        cart
    },

    mixins: [orderMixin],

    state: {
        ...defaultState,
    },
    getters: {
        getMotor: (state, getters, rootState) => {
            return rootState.motors.byId[state.motor];
        },
        getTank: (state, getters, rootState) => {
            return rootState.tanks.byId[state.tank];
        },
        getLid(state, getters, rootState, rootGetters) {
            return rootGetters['lids/getById'](state.lid);
        },
        getWheels: (state, getters, rootState, rootGetters) => {
            if (!state.wheels) return null;

            const tank = getters.getTank;
            const wheelsId = tank.wheels_id;
            const options = rootGetters["powerpackOptions/getAll"];

            return options.find(option => option.id === wheelsId);
        },
        getCooler: (state, getters, rootState, rootGetters) => {
            if (!state.cooler) return null;

            const tank = getters.getTank;
            const coolerId = tank.cooler_id;
            const options = rootGetters["powerpackOptions/getAll"];

            return options.find(option => option.id === coolerId);
        },
        getSupport: (state, getters, rootState, rootGetters) => {
            const options = rootGetters["powerpackOptions/getAll"];
            const support = options.find((option) => {
                return option.type === 'support';
            })

            return (support && support.selected ? support : null);
        },
        getBestTank: (state, getters, rootState, rootGetters) => {
            let tanks;

            switch (getters.getMotorOption){
                case 'workplace': {
                    const tankSizeFactor = 1.3;
                    const lpm = getLPM(rootState.pumps.byId[state.pump].cc, getters.getMotor.rpm) * tankSizeFactor;

                    tanks = rootGetters['tanks/getAvailableTanks'];
                    for (let tank of tanks) {
                        if (tank.liters >= lpm) {
                            return tank.id
                        }
                    }

                    return tanks[0].id
                }
                case 'industrial' : {
                    tanks = rootGetters['tanks/getAvailableTanks'];

                    return tanks[0]?.id
                }
                case 'mini_powerpack': {
                    const tankSizeFactor = 1.5;
                    const lpm = getLPM(rootState.pumps.byId[state.pump].cc, getters.getMotor.rpm) * tankSizeFactor;

                    tanks = rootGetters['tanks/getAvailableTanks'];
                    for (let tank of tanks) {
                        if (tank.liters >= lpm) {
                            return tank.id
                        }
                    }

                    return tanks[tanks.length-1].id
                }
                default: {
                    tanks = rootGetters['tanks/getTanks'];

                    return tanks[0]?.id
                }
            }
        },

        getBestPump: (state, getters, rootState, rootGetters) => {
            // @todo this function should be overhauled.
            const lpm = rootState.preference.liters;
            const rpm = rootState.motors.byId[state.motor].rpm;
            const cc = getCC(lpm, rpm).toFixed(2) || 0;

            let pumps;
            if (getters.getMotorOption === 'and_pump' || getters.getMotorOption === 'workplace' || getters.getMotorOption === 'industrial') {
                pumps = rootGetters['pumps/getAvailablePumps'];
            } else {
                pumps = rootGetters['pumps/getPumps'];
            }

            let i;
            for (i = 0; i < pumps.length; i++) {
                if (pumps[i].cc && pumps[i].cc >= cc && pumps[i - 1] !== undefined) {
                    return pumps[i - 1].id;
                }
            }
            return pumps[i - 1] ? pumps[i - 1].id : pumps[0];
        },
        lpm: (state, getters, rootState) => {
            const pump = rootState.pumps.byId[state.pump]; //getters.getPump
            const motor = rootState.motors.byId[state.motor] //getters.getMotor;
            let cc = pump ? pump.cc : 0;
            let rpm = motor ? motor.rpm : 0;
            return getLPM(cc, rpm).toFixed(2) || 0
        },
        cc: (state, getters, rootState) => {
            const tank = rootState.tanks.byId[state.tank]; //getters.getTank;
            const motor = rootState.motors.byId[state.motor] //getters.getMotor;
            let lpm = tank ? tank.liters : 0;
            let rpm = motor ? motor.rpm : 0;
            return getCC(lpm, rpm).toFixed(2) || 0;
        },
        rpm: (state, getters, rootState) => {
            const pump = rootState.pumps.byId[state.pump]; //getters.getPump;
            const tank = rootState.tanks.byId[state.tank]; //getters.getTank;
            let cc = pump ? pump.cc : 0;
            let lpm = tank ? tank.liters : 0;
            return getRPM(cc, lpm).toFixed(2) || 0;
        },
        requiredPower: (state, getters, rootState) => {
            let calculationFactor = getters.getMotor ? getters.getMotor.calculation_factor : 0;
            let lpm = getters.lpm;
            let pressure = rootState.preference.safetyPressure;
            // return calculationFactor ? (getters.lpm * getters.maxPressure) / calculationFactor : 0;
            return calculationFactor ? lpm * pressure / calculationFactor : 0;
        },
        maxPressure: (state, getters, rootState) => {
            let calculationFactor = getters.getMotor ? getters.getMotor.calculation_factor : 0;
            let kw = getters.getMotor ? getters.getMotor.kw : 0;
            let liters = parseFloat(getters.lpm);//tank ? tank.liters : 0;
            return liters ? (kw * calculationFactor) / liters : 0;
        },
        getCircuit: (state, getters, rootState) => {
            return rootState.circuits.all.find((element) => {
                return element.id === state.circuit;
            });
        },
        getPump: (state, getters, rootState) => {
            return rootState.pumps.all.find((element) => {
                return element.id === state.pump;
            });
        },
        getMotorOption(state, getters, rootState) {
            for (let key in rootState.preference.motorOptions)
            if (rootState.preference.motorOptions[key]) return key;
        },
        getBuildObject(state, getters, rootState, rootGetters) {
            switch (getters.getMotorOption) {
                case 'mini_powerpack':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        valve_type: state.valveType,
                        circuit: state.circuit,
                        pump: state.pump,
                        tank: state.tank,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        lid: null,
                        wheels: null,
                        cooler: null,
                        electrical_box: null,
                        safety_pressure: rootState.preference.safetyPressure,
                        powerpack_options: rootGetters["powerpackOptions/getBuildObject"],
                        return_throttling: (getters.getMotorOption === 'mini_powerpack' && state.valveType === 1) ? state.returnThrottling : null,
                        valves: getters["valves/getBuildObject"],
                        retourFilter: state.extraProductId ? state.extraProductId : null,
                    };
                case 'industrial':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        valve_type: state.valveType,
                        circuit: state.circuit,
                        pump: state.pump,
                        tank: state.tank,
                        tanker_float: state.tankerFloat,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        lid: state.lid,
                        wheels: null,
                        cooler: null,
                        electrical_box: null,
                        elastic_coupling: getters.getElasticCoupling ? getters.getElasticCoupling.id : null,
                        lantern_piece: getters.getLanternPiece ? getters.getLanternPiece.id : null,
                        safety_pressure: rootState.preference.safetyPressure,
                        powerpack_options: null,
                        return_throttling: (getters.getMotorOption === 'industrial' && state.valveType === 1) ? state.returnThrottling : null,
                        valves: getters["valves/getBuildObject"],
                        retourFilter: state.extraProductId ? state.extraProductId : null,
                    };
                case 'workplace':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        valve_type: state.valveType,
                        circuit: state.circuit,
                        pump: state.pump,
                        tank: state.tank,
                        tanker_float: state.tankerFloat,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        lid: getters.getLid ? getters.getLid.id : null,
                        wheels: getters.getWheels ? getters.getWheels.id : null,
                        cooler: getters.getCooler ? getters.getCooler.id : null,
                        elastic_coupling: getters.getElasticCoupling ? getters.getElasticCoupling.id : null,
                        lantern_piece: getters.getLanternPiece ? getters.getLanternPiece.id : null,
                        electrical_box: state.electricalBox ? state.electricalBox : null,
                        safety_pressure: rootState.preference.safetyPressure,
                        powerpack_options: [], //rootGetters["powerpackOptions/getBuildObject"],
                        return_throttling: (getters.getMotorOption === 'mini_powerpack' && state.valveType === 1) ? state.returnThrottling : null,
                        valves: getters["valves/getBuildObject"],
                        retourFilter: state.extraProductId ? state.extraProductId : null,
                    }
                case 'and_pump':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        valve_type: null,
                        circuit: null,
                        pump: state.pump,
                        tank: null,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        lid: null,
                        wheels: null,
                        cooler: null,
                        elastic_coupling: getters.getElasticCoupling ? getters.getElasticCoupling.id : null,
                        lantern_piece: getters.getLanternPiece ? getters.getLanternPiece.id : null,
                        electrical_box: null,
                        safety_pressure: null,
                        powerpack_options: [],
                        return_throttling: null,
                        valves: null,
                        dynamo: state.dynamo,
                    }
                case 'open_frame':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        pump: state.pump,
                        tank: state.tank,
                        tanker_float: state.tankerFloat,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        elastic_coupling: getters.getElasticCoupling ? getters.getElasticCoupling.id : null,
                        lantern_piece: getters.getLanternPiece ? getters.getLanternPiece.id : null,
                        safety_pressure: rootState.preference.safetyPressure,
                        powerpack_options: rootGetters["openFrameOptions/getBuildObject"],
                        valves: getters["valves/getBuildObject"],
                        retourFilter: state.extraProductId ? state.extraProductId : null,
                    }
                case 'closed_frame':
                    return {
                        motor_option: getters.getMotorOption,
                        motor: state.motor,
                        pump: state.pump,
                        tank: state.tank,
                        water_absorbent_tank_aeration: state.waterAbsorbentTankAeration,
                        elastic_coupling: getters.getElasticCoupling ? getters.getElasticCoupling.id : null,
                        lantern_piece: getters.getLanternPiece ? getters.getLanternPiece.id : null,
                        safety_pressure: rootState.preference.safetyPressure,
                        powerpack_options: rootGetters["closedFrameOptions/getBuildArray"],
                        retourFilter: state.extraProductId ? state.extraProductId : null,
                    }
            }
        },

        getElectricalBox(state, getters, rootState) {
            for (const eBox of rootState.electricalBoxes.all) {
                if (eBox.id === state.electricalBox) {
                    return eBox;
                }
            }
        },

        getOilCooler(state, getters, rootState) {
            for (const oilCooler of rootState.oilCoolers.all) {
                if (oilCooler.id === state.oilCooler) {
                    return oilCooler;
                }
            }
        },

        getLanternPiece(state, getters, rootState, rootGetters) {
            const motor = getters.getMotor;
            if (!motor || !motor.flange_size) return null;

            const pump = getters.getPump;
            if (!pump || !pump.pump_group_id) return null;

            const flangeSize = motor.flange_size;
            const pumpGroupId = pump.pump_group_id;

            return rootGetters['lanternPieces/getByFlangeSizeAndPumpGroup'](flangeSize, pumpGroupId);
        },

        getElasticCoupling(state, getters, rootState, rootGetters) {
            const motor = getters.getMotor;
            if (!motor || !motor.flange_size) return null;

            const pump = getters.getPump;
            if (!pump || !pump.pump_group_id) return null;

            const flangeSize = motor.flange_size;
            const pumpGroupId = pump.pump_group_id;

            return rootGetters['elasticCouplings/getByFlangeSizeAndPumpGroup'](flangeSize, pumpGroupId);
        },
        getTankerFloat(state, getters, rootState, rootGetters){
          return rootGetters['tankerFloats/getTankerFloatById'](state.tankerFloat)
        },
        getDynamo(state, getters, rootState, rootGetters){
            return rootGetters['powerpackOptions/getObjectById'](state.dynamo)
        },
        getWaterAbsorbentTankAeration(state, getters, rootState, rootGetters){
            return rootGetters['waterAbsorbentTankAerations/getWaterAbsorbentTankAerationById'](state.waterAbsorbentTankAeration)
        },
        hasTankerFloat(state) {
            return state.tankerFloat !== null;
        },
        hasDynamo(state) {
            return state.dynamo !== null;
        },
        hasWaterAbsorbentTankAeration(state) {
            return state.waterAbsorbentTankAeration !== null;
        },
        getExtraProductId(state) {
            return state.extraProductId;
        }
    },
    actions: {
        resetState({commit}) {
            commit('resetState');
            commit('valves/updateAllValves', []);
        },
        fetchBuild({dispatch}, uid) {
            return axios.get(process.env.VUE_APP_API_URL + 'powerpack/builds/' + uid)
                .then(({data}) => {
                    return data;
                });
        },

        async loadBuild({dispatch, rootState, rootGetters, getters, commit}, build) {
            await dispatch('resetState');

            if (build === undefined) {
                let storedBuild = localStorage.getItem('build_data');
                build = JSON.parse(storedBuild);

                if (!build) {
                    router.push('/powerpack-motor-configurator');
                    return;
                }
            }

            commit('setLoading', true);
            commit('setMotor', build.motor);
            commit('preference/setMotorOption', build.motor_option, {root: true});
            commit('setValveType', build.valve_type);
            commit('setCircuit', build.circuit);
            commit('setPump', build.pump);
            commit('setTank', build.tank);
            commit('setDynamo', build.dynamo);
            commit('setLid', build.lid);
            commit('setWheels', build.wheels);
            commit('setCooler', build.cooler);
            commit('setElectricalBox', build.electrical_box);
            commit('preference/updateSafetyPressure', build.safety_pressure, {root: true});
            commit('setWaterAbsorbentTankAeration', build.water_absorbent_tank_aeration);
            commit('setTankerFloat', build.tanker_float);
            commit('setExtraProduct', build.extra_product_id);

            // Powerpack Options
            rootState.powerpackOptions.all.forEach((option, index) => {
                if (build.powerpack_options && build.powerpack_options.includes(option.id)) {
                    commit('powerpackOptions/setSelected', {index, bool: true}, {root: true});
                } else {
                    commit('powerpackOptions/setSelected', {index, bool: false}, {root: true});
                }
            });

            if (build.motor_option === 'open_frame') {
                rootState.openFrameOptions.all.forEach((option, index) => {
                    if (build.powerpack_options && build.powerpack_options.includes(option.id)) {
                        commit('openFrameOptions/setSelected', {index, bool: true}, {root: true});
                    } else {
                        commit('openFrameOptions/setSelected', {index, bool: false}, {root: true});
                    }
                });
            }

            commit('valves/dropValves');
            if (build.valves) {
                build.valves.forEach(valve => {
                    commit('valves/addValveWithAdditionalValves', {
                        block: valve.block,
                        id: valve.valve,
                        additionalValves: valve.additionalValves,
                    });
                });
            }

            commit('setLoading', false);
            dispatch('saveBuild');
        },
        saveBuild({getters}) {
            localStorage.setItem('build_data', JSON.stringify(getters.getBuildObject));
        },
        setBestTank({getters, commit, dispatch}) {
            let best = getters.getBestTank;

            commit('setTank', best); // Set last tank
            dispatch('setLid');
        },

        setLid({state, rootGetters, commit}) {
            const lids = rootGetters["lids/getAll"];
            let tankId = state.tank;
            let motor = rootGetters['build/getMotor'];
            let lid = lids.find((lid) => {
                return lid.tank_id === tankId && motor.flange_size === lid.flange_size;
            });

            if (lid) {
                commit('setLid', lid.id);
            } else {
                commit('setLid', null);
            }
        },

        setBestPump({commit, getters}) {
            let best = getters.getBestPump
            commit('setPump', best);
        },

        setExtraProduct({commit}, extraProduct) {
            commit('setExtraProduct', extraProduct);
        },

        selectMotor({dispatch, commit}, id) {
            if (typeof id !== "number") {
                return 'Error: action param is not a number'
            }

            commit('setMotor', id);
        },
        selectCilinder({dispatch, commit}, id) {
            if (typeof id !== "number") {
                return 'Error: action param is not a number'
            }

            commit('setCilinder', id);
        },
        setValveType: ({commit, getters, rootState}, id) => {
            commit('setValveType', id);

            let circuit = getters['build/getCircuit'];
            if (!circuit || circuit.valve_type !== id) {
                const newCircuit = rootState.circuits.all.find((element) => {
                    return element.valve_type === id;
                });

                commit('setCircuit', newCircuit ? newCircuit.id : null);
            }
        },
        setTank: ({commit, dispatch}, id) => {
            if (typeof id !== "number") {
                return 'Error: action param is not a number'
            }

            commit('setTank', id);
            dispatch('setLid');

        },
        setPump: ({commit}, id) => {
            if (typeof id !== "number") {
                return 'Error: action param is not a number'
            }
            commit('setPump', id);
        },
        setMotor: ({commit}, id) => {
            if (typeof id !== "number") {
                return 'Error: action param is not a number'
            }
            commit('setMotor', id);
        },
        selectElectricalBox: ({commit}, id) => {
            commit('setElectricalBox', id);
        },
        selectOilCooler: ({commit}, id) => {
            commit('setOilCooler', id);
        },
    },
    mutations: {
        resetState(state) {
            state = Object.assign(state, defaultState);
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setMotor(state, id) {
            state.motor = id;
        },
        setPump(state, id) {
            state.pump = id;
        },
        setTank(state, id) {
            state.tank = id;
        },
        setLid(state, lid) {
            state.lid = lid;
        },
        setCircuit(state, id) {
            state.circuit = id;
        },
        setCilinder(state, id) {
            state.cilinder = id;
        },
        setValveType(state, val) {
            state.valveType = val;
        },
        setElectricalBox(state, id) {
            state.electricalBox = id;
        },
        setOilCooler(state, id) {
            state.oilCooler = id;
        },
        setWheels(state, bool) {
            state.wheels = bool;
        },
        setCooler(state, bool) {
            state.cooler = bool;
        },
        setTankerFloat(state, tankerfloat) {
            state.tankerFloat = state.tankerFloat !== tankerfloat ? tankerfloat : null
        },
        setDynamo(state, dynamo) {
            state.dynamo = state.dynamo !== dynamo ? dynamo : null
        },
        setWaterAbsorbentTankAeration(state, waterAbsorbentTankaeration) {
            state.waterAbsorbentTankAeration = state.waterAbsorbentTankAeration !== waterAbsorbentTankaeration ? waterAbsorbentTankaeration : null
        },
        setExtraProduct(state, extraProductId) {
            state.extraProductId = extraProductId;
        },
        setReturnWheels(state, value) {
            if (!['false', 'true'].includes(value)) {
                throw "not allowed";
            }

            state.returnWheels.selected = value;
        },
    }
};
